"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allUsersQuery = void 0;
const client_1 = require("@apollo/client");
exports.allUsersQuery = client_1.gql `
  query AllUsers($email: String!) {
    allUsers(email: $email) {
      id
      email
    }
  }
`;
//# sourceMappingURL=AllUsers.js.map